/* annotations.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import "./annotations.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */

import React from 'react';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import { fg } from '@atlaskit/platform-feature-flags';
var formInputBaseStyles = null;

/**
 * By default, the visual pdf form elements are rendered by pdfium server side. Therefore we only
 * show visibility of the html input if the user interacts with it. This allows us to show visually
 * accurate PDF form elements while still allowing the user to interact with the input.
 */
var invisibleInputStyles = null;
var textInputStyles = null;
var foreignObjectProps = {
  xmlns: 'http://www.w3.org/1999/xhtml'
};
var TextInput = function TextInput(_ref) {
  var Component = _ref.as,
    value = _ref.value,
    style = _ref.style;
  return /*#__PURE__*/React.createElement(Component, _extends({}, foreignObjectProps, {
    style: style,
    onKeyUp: function onKeyUp(e) {
      // stop propagation of the arrow key events because they can be used to navigate viewports
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.stopPropagation();
      }
    },
    value: value,
    type: "text",
    readOnly: true,
    className: ax(["_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ect41ttw _vwz410nf _r06hglyw _14zgglyw", "_kqswstnw _4t3i1osq _vchhusvi _1bsb1osq", fg('media-document-viewer-annotations') && "_1reo15vq _18m915vq _bfhk1j28 _syaz1j28 _p6m71wug _1chs1wug _jomru67f _f8pjr3uz"])
  }));
};
export var TextInputFormField = function TextInputFormField(_ref2) {
  var field = _ref2.field,
    dataTestId = _ref2.dataTestId;
  var style = _defineProperty({}, 'fontSize', "".concat(field.f, "px"));
  return /*#__PURE__*/React.createElement("foreignObject", {
    x: field.x,
    y: -field.y,
    width: field.w,
    height: field.h,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(TextInput, {
    style: style,
    as: field.multiline ? 'textarea' : 'input',
    value: field.text
  }));
};
var comboBoxStyles = null;
var comboBoxInputStyles = null;
export var ComboBoxFormField = function ComboBoxFormField(_ref3) {
  var field = _ref3.field,
    dataTestId = _ref3.dataTestId;
  return /*#__PURE__*/React.createElement("foreignObject", {
    x: field.x,
    y: -field.y,
    width: field.w,
    height: field.h,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement("div", _extends({}, foreignObjectProps, {
    className: ax(["_1e0c11p5 _yv0e1ghl _4cvr1h6o _1bah1yb4 _kqswstnw _4t3i1osq _1bsb1osq"])
  }), /*#__PURE__*/React.createElement("input", {
    style: _defineProperty({}, 'fontSize', "".concat(field.f, "px")),
    type: "text",
    value: field.text
    // stop propagation of the arrow key events because they can be used to navigate viewports
    ,
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.stopPropagation();
      }
    },
    readOnly: true,
    className: ax(["_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ect41ttw _vwz410nf _r06hglyw _14zgglyw", "_1bsb1osq", fg('media-document-viewer-annotations') && "_1reo15vq _18m915vq _bfhk1j28 _syaz1j28 _p6m71wug _1chs1wug _jomru67f _f8pjr3uz"])
  }), !fg('media-document-viewer-annotations') && /*#__PURE__*/React.createElement(ChevronDownIcon, {
    label: "",
    size: "small"
  })));
};
export var Annotations = function Annotations(_ref5) {
  var annotations = _ref5.annotations;
  return /*#__PURE__*/React.createElement(React.Fragment, null, annotations.text_form_fields.map(function (field, i) {
    return /*#__PURE__*/React.createElement(TextInputFormField, {
      field: field,
      dataTestId: "text-form-field-".concat(i),
      key: i
    });
  }), annotations.combobox_form_fields.map(function (field, i) {
    return /*#__PURE__*/React.createElement(ComboBoxFormField, {
      field: field,
      dataTestId: "combobox-form-field-".concat(i),
      key: i
    });
  }));
};